/* stylelint-disable selector-max-compound-selectors */
$title--color: var(--title-color, initial);
$title--fs: var(--title-fs, initial);

:host {
  @include reset-host;
  @include reset-text;
}

:host .title {
  display: block;

  color: #{$title--color};
  font-size: #{$title--fs};
  line-height: 1.2;

  &.is-xxs {
    font-size: rem(20);

    @include mq('max', 'md') {
      font-size: rem(20);
    }
  }

  &.is-xs {
    font-size: rem(24);

    @include mq('max', 'md') {
      font-size: rem(14);
    }
  }

  &.is-sm {
    font-size: rem(36);

    @include mq('max', 'md') {
      font-size: rem(28);
    }
  }

  &.is-md {
    font-size: rem(40);

    @include mq('max', 'md') {
      font-size: rem(32);
    }
  }

  &.is-lg {
    font-size: rem(48);

    @include mq('max', 'md') {
      font-size: rem(25);
    }
  }

  &.is-xl {
    font-size: rem(54);

    @include mq('max', 'md') {
      font-size: rem(30);
    }
  }

  &.is-xxl {
    font-size: rem(90);

    @include mq('max', 'md') {
      font-size: rem(64);
    }
  }

  &.has-xs-margin {
    margin-bottom: map-get($spacing-sizes, 1);
  }

  &.has-sm-margin {
    margin-bottom: map-get($spacing-sizes, 2);
  }

  &.has-md-margin {
    margin-bottom: map-get($spacing-sizes, 3);
  }

  &.has-lg-margin {
    margin-bottom: map-get($spacing-sizes, 4);
  }

  &.has-xl-margin {
    margin-bottom: map-get($spacing-sizes, 5);
  }

  &.has-text-centered {
    text-align: center;
  }

  &.is-bold {
    font-weight: $fw-medium;
  }

  em {
    font-size: 1.35em;
    font-family: $ff-title;
    font-style: normal;
    line-height: 0;
  }
}
